import { CheckCircle, AlertCircle, Sparkles } from 'lucide-react';
import * as React from 'react';

import {
  SIZE_SCALE,
  GAP_SCALE,
  POSITION_SCALE,
  TYPE_SCALE,
  COLOR_SCALE,
} from '@/components/design-system/tokens';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '@/components/ui/Toast';
import { useToast } from '@/components/ui/useToast';

interface ToastData {
  id: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'destructive' | 'welcome';
  [key: string]: unknown;
}

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }: ToastData) {
        const isDestructive = variant === 'destructive';
        const isWelcome = variant === 'welcome';

        let Icon, iconColor;
        if (isDestructive) {
          Icon = AlertCircle;
          iconColor = COLOR_SCALE['toast-error'];
        } else if (isWelcome) {
          Icon = Sparkles;
          iconColor = COLOR_SCALE['toast-info'];
        } else {
          Icon = CheckCircle;
          iconColor = COLOR_SCALE['toast-success'];
        }

        return (
          <Toast
            key={id}
            variant={variant === 'welcome' ? 'default' : (variant ?? 'default')}
            {...props}
          >
            <div className={`flex items-start ${GAP_SCALE['3']} flex-1`}>
              <div className={`flex-shrink-0 ${POSITION_SCALE.top[0]}`}>
                <Icon className={`${SIZE_SCALE['5']} ${iconColor}`} />
              </div>
              <div className={`grid ${GAP_SCALE['1']} flex-1`}>
                {title && (
                  <ToastTitle className={isWelcome ? TYPE_SCALE.lg : ''}>{title}</ToastTitle>
                )}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            {!isWelcome && <ToastClose onClick={() => dismiss(id)} />}
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
